export default "__VITE_ASSET__hqioAyvs__"